import {
  Home,
  Package,
  Tag,
  Wallet,
  Store,
  ShoppingCart,
  Star,
  Settings,
  Car,
  Image,
  Utensils,
  Gift,
  Boxes,
  Ticket,
  Layers,
  PersonStanding,
  Medal,
  UserCog,
  Users,
  UserSquare,
  Cog,
  TicketIcon,
  Contact,
  Newspaper,
} from "lucide-react";
import { PermissionsKey } from "./permissions";

export const adminSidebarLinks = [
  {
    title: "admin_sidebar.home",
    href: "/admin",
    icon: Home,
  },
  {
    title: "admin_sidebar.catalog",
    icon: Boxes,
    children: [
      {
        title: "admin_sidebar.car_brand",
        href: "/admin/car-brands",
        icon: Car,
        permission: PermissionsKey.ViewCarBrand,
      },
      {
        title: "admin_sidebar.avatars",
        href: "/admin/avatars",
        icon: Image,
        permission: PermissionsKey.ViewAvatar,
      },
      {
        title: "admin_sidebar.store_type",
        href: "/admin/store-types",
        icon: Tag,
        permission: PermissionsKey.ViewTypeOfStore,
      },
      {
        title: "admin_sidebar.sectors",
        href: "/admin/sectors",
        icon: Utensils,
        permission: PermissionsKey.ViewSector,
      },
      {
        title: "admin_sidebar.gift_catgeories",
        href: "/admin/gift-categories",
        icon: Gift,
        permission: PermissionsKey.ViewGiftCategory,
      },
      {
        title: "admin_sidebar.variant_categories",
        href: "/admin/variant-categories",
        icon: Boxes,
        permission: PermissionsKey.ViewVariantCategory,
      },
      {
        title: "admin_sidebar.loyalty_offers",
        href: "/admin/loyalty-offers",
        icon: Tag,
        permission: PermissionsKey.ViewLoyaltyOffer,
      },
      {
        title: "admin_sidebar.coupouns",
        href: "/admin/coupouns",
        icon: Ticket,
        permission: PermissionsKey.ViewCoupon,
      },
      {
        title: "admin_sidebar.points",
        href: "/admin/points",
        icon: Medal,
        permission: PermissionsKey.SystemPoints,
      },
      {
        title: "admin_sidebar.contact_settings",
        href: "/admin/contact-info",
        icon: Contact,
        permission: PermissionsKey.SystemSettings,
      },
      {
        title: "admin_sidebar.site_content",
        href: "/admin/site-content",
        icon: Newspaper,
        permission: PermissionsKey.LandingPage,
      },
    ],
  },
  {
    title: "owner_sidebar.stores",
    href: "/admin/stores",
    icon: Store,
    permission: PermissionsKey.ViewStores,
  },
  {
    title: "admin_sidebar.owners",
    href: "/admin/owners",
    icon: PersonStanding,
    permission: PermissionsKey.ViewOwners,
  },
  // {
  //   title: "admin_sidebar.customers",
  //   href: "/admin/customers",
  //   icon: UserSquare,
  //   permission: PermissionsKey.ViewCustomer,
  // },
  {
    title: "settings",
    icon: Cog,
    children: [
      {
        title: "admin_sidebar.roles",
        href: "/admin/roles",
        icon: UserCog,
        permission: PermissionsKey.viewRole,
      },
      {
        title: "admin_sidebar.employees",
        href: "/admin/employees",
        icon: Users,
        permission: PermissionsKey.ViewAdmin,
      },
    ],
  },
];

// owner sidebar links

export const storeSidebarLinks = [
  {
    title: "owner_sidebar.dashboard",
    href: "/store/dashboard",
    icon: Home,
  },
  {
    title: "owner_sidebar.orders",
    href: "/store/orders",
    icon: ShoppingCart,
  },
  {
    title: "categories",
    href: "/store/categories",
    icon: Layers,
  },
  {
    title: "owner_sidebar.products",
    href: "/store/products",
    icon: Package,
  },
  {
    title: "owner_sidebar.offers",
    href: "/store/offers",
    icon: Tag,
  },
  {
    title: "owner_sidebar.Customers_Reviews",
    href: "/store/reviews",
    icon: Star,
  },
  {
    title: "owner_sidebar.Transactions",
    href: "/store/transactions",
    icon: Wallet,
  },
  // {
  //   title: "owner_sidebar.tickets",
  //   href: "/store/tickets",
  //   icon: TicketIcon,
  // },
];

export const ownerSidebarLinks = [
  {
    title: "owner_sidebar.stores",
    href: "/owner/stores",
    icon: Store,
  },
  {
    title: "owner_sidebar.settings",
    href: "/owner/settings",
    icon: Settings,
  },
];

export const OnlyStoreSidebarLinks = [
  {
    title: "owner_sidebar.settings",
    href: "/store/settings",
    icon: Settings,
  },
];
